import React from 'react'
import TradeInContainer from './TradeInContainer'

const TradeIn = () => <TradeInContainer data-test="component-stock-trade-in" />

export default TradeIn
